import * as React from 'react';
import "./pageHeaderView.scss";

interface Props {
	/**
	 * Page header text.
	 */
	header?: string;
}

/**
 * Page header component displays title on the top of the page.
 */
export default class PageHeaderView extends React.Component<Props, {}> {
	render() {

		return (
			<div className="c-subheader">
				{this.props.header && <h3 className={"c-subheader_title"}>{this.props.header}</h3>}
				{this.props.children}
			</div>
		);
	}
}